import React, { useMemo } from 'react';
import translations from './OutputDataTimeSeriesButton.translations.json';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import { Button, Dropdown } from 'antd';
import * as Icon from 'react-feather';
import { DropdownItem } from '@atlas-frontend/sdk';
import { ButtonProps } from 'antd/lib';
import { MenuInfo } from 'rc-menu/lib/interface';
import {
  OUTPUT_DATA_TIME_SERIES_ACTIONS,
  OutputDataTimeSeriesActionKey,
} from '../OutputDataDirectory';

const { addTranslations, t } = i18nNsFactory('output-data-time-series-button');
addTranslations(translations);

export type OutputDataTimeSeriesButtonProps = Omit<
  ButtonProps,
  'id' | 'onClick'
> & {
  onAction: (actionKey: OutputDataTimeSeriesActionKey) => void;
};

export const OutputDataTimeSeriesButton: React.FC<
  OutputDataTimeSeriesButtonProps
> = ({ onAction, ...rest }) => {
  const actionMenu = useMemo(
    () => ({
      items: OUTPUT_DATA_TIME_SERIES_ACTIONS.map((actionKey) => ({
        label: <DropdownItem>{t(`actions.${actionKey}`)}</DropdownItem>,
        key: actionKey,
      })),
      onClick: (e: MenuInfo) => {
        onAction(e.key as OutputDataTimeSeriesActionKey);
      },
    }),
    [onAction],
  );

  return (
    <Dropdown menu={actionMenu} trigger={['click']}>
      <Button id="output-data-time-series-button" {...rest}>
        {t('title')}
        <Icon.ChevronDown size={18} />
      </Button>
    </Dropdown>
  );
};
